import { withTranslation, Trans } from "react-i18next";
import LanguageSelector from "../common/LanguageSelector";
import React from "react";
import "../../assets/css/auth.css";
import { BlackLogo } from "../common/BlackLogo";
import axios from "axios";
import PropTypes from "prop-types";
import { login, loadUser } from "../../actions/auth";
import { bindActionCreators } from "redux";
import Alert from "../common/Alert";
import { connect } from "react-redux";
import { NavLink, Navigate } from "react-router-dom";
import GoogleSignInButton from "../common/GoogleSignInButton";
import scriptjs from "scriptjs";
import { setInvite, removeInvite } from "../../actions/invite_ids";
import { setAlert } from "../../actions/alert";
import { motion } from "framer-motion";
import CanvasRevealEffect from "../common/CanvasRevealEffect";
import { generatePassword } from "../../utils/password";
import { trackPlausibleEvent } from "../../utils/plausible";

// Sign in with Apple is off until the Apple Services ID is set up again; build with REACT_APP_APPLE_SIGNIN=true to show it
const APPLE_SIGNIN_ENABLED = process.env.REACT_APP_APPLE_SIGNIN === "true";

export class Login extends React.Component {
  constructor(props) {
    super();
    this.state = {
      email: "",
      password: "",
      errors: {},
      hidden: true,
      isAuthenticated: false,
      workspace_id: 0,
      invite_id: 0,
      password_check: { length: false, number: false, letter: false, special: false },
      rememberMe: !!localStorage.getItem("mz_remember_email"),
    };
  }

  componentDidMount() {
    trackPlausibleEvent("Login Page Viewed");
    const savedEmail = localStorage.getItem("mz_remember_email");
    if (savedEmail) this.setState({ email: savedEmail });
    this.checkUser();
    this.checkApple();
    if (APPLE_SIGNIN_ENABLED) scriptjs.get("https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js", () => {
      const params = {
        clientId: process.env.REACT_APP_APPLE_CLIENT_ID || "minutezilla.com",
        redirectURI: "https://app.minutezilla.com/api/apple/verify",
        scope: "name email",
      };
      window.AppleID.auth.init(params);
    });
  }

  signin = async (res) => {
    try {
      const config = { headers: { Accept: "application/json", "Content-Type": "application/json" } };
      let { workspace_id, invite_id } = this.state;
      const body = JSON.stringify({ email: res.email, workspace_id, invite_id });
      let res1 = await axios.post("/api/google/signin", body, config);
      if (res1.status === 200) {
        await this.props.loadUser(res1);
        await this.props.removeInvite();
        trackPlausibleEvent("Login Completed", { method: "google" });
        this.setState({ isAuthenticated: true });
      }
    } catch (error) {
      console.log(error);
      trackPlausibleEvent("Login Failed", {
        method: "google",
        reason: error?.response?.data?.errors?.[0]?.msg || error?.message || "unknown",
      });
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) errors.forEach((e) => this.props.setAlert(e.msg, "danger"));
      }
    }
  };

  checkUser = async () => {
    let url = new URL(window.location.href);
    let c = url.searchParams.get("data");
    if (c) {
      let data = atob(c).split(" ");
      await this.props.setInvite(data[2], data[0]);
      this.setState({ email: data[1], workspace_id: data[0], invite_id: data[2] });
    }
  };

  checkApple = async () => {
    try {
      let url = new URL(window.location.href);
      if (url.searchParams.get("apple_error")) {
        this.props.setAlert("Sign in with Apple failed, please try again", "danger");
      }
      let apple_token = url.searchParams.get("apple_token");
      if (apple_token) {
        window.history.replaceState(null, "", window.location.pathname);
        const config = { headers: { Accept: "application/json", "Content-Type": "application/json" } };
        let password = generatePassword({ length: 10, numbers: true });
        let workspace_id, invite_id;
        if (this.props.invite_ids.payload !== undefined && this.props.invite_ids.payload !== null && this.props.invite_ids.payload !== "") {
          workspace_id = this.props.invite_ids.payload.invite_wid;
          invite_id    = this.props.invite_ids.payload.invite_id;
        } else {
          workspace_id = this.props.invite_ids.invite_wid;
          invite_id    = this.props.invite_ids.invite_id;
        }
        const body = JSON.stringify({ apple_token, password, workspace_id, invite_id });
        let res1 = await axios.post("/api/apple/user", body, config);
        if (res1.status === 200 && res1.data.confirmation === true) {
          await this.props.loadUser(res1);
          await this.props.removeInvite();
          trackPlausibleEvent("Login Completed", { method: "apple" });
          this.setState({ isAuthenticated: true });
        }
      }
    } catch (error) {
      console.log(error);
      trackPlausibleEvent("Login Failed", {
        method: "apple",
        reason: error?.response?.data?.errors?.[0]?.msg || error?.message || "unknown",
      });
      if (error.response) {
        const errors = error.response.data.errors;
        if (errors) errors.forEach((e) => this.props.setAlert(e.msg, "danger"));
      }
    }
  };

  toggleShow = () => this.setState({ hidden: !this.state.hidden });
  onChange   = (e) => this.setState({ [e.target.name]: e.target.value, errors: {} });

  validateForm = () => {
    let { email, password } = this.state;
    let errors = {}, formIsValid = true;
    if (!email) { formIsValid = false; errors.email = "auth_please_enter_your_email_address"; }
    if (email) {
      const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
      if (!pattern.test(email)) { formIsValid = false; errors.email = "auth_please_enter_a_valid_email_address"; }
    }
    if (!password) { formIsValid = false; errors.password = "auth_please_enter_your_password"; }
    this.setState({ errors });
    return formIsValid;
  };

  loginUser = async (e) => {
    e.preventDefault();
    try {
      if (this.validateForm()) {
        let { email, password, workspace_id, invite_id, rememberMe } = this.state;
        trackPlausibleEvent("Login Started", { method: "password" });
        if (rememberMe) {
          localStorage.setItem("mz_remember_email", email);
        } else {
          localStorage.removeItem("mz_remember_email");
        }
        await this.props.login({ email, password, workspace_id, invite_id });
        this.setState({ isAuthenticated: true });
      } else {
        trackPlausibleEvent("Login Failed", { method: "password", reason: "validation" });
      }
    } catch (error) {
      console.log(error);
    }
  };

  checkPassword = () => {
    let p = this.state.password;
    this.setState({
      password_check: {
        length:  p.length > 8,
        letter:  /[a-z]/.test(p) && /[A-Z]/.test(p),
        number:  /[0-9]/.test(p),
        special: /[!@#$]/.test(p),
      },
    });
  };

  hanldeKeydown = (e) => { if (e.keyCode === 13) { e.preventDefault(); this.loginUser(e); } };

  render() {
    const responseGoogle = (profile) => { if (profile && profile.email) this.signin(profile); };
    const googleError = (error) => {
      const message =
        error?.message ||
        error?.error_description ||
        error?.details ||
        this.props.t("auth_google_sign_in_could_not_be_completed_please_try_again");
      this.props.setAlert(message, "danger");
    };
    if (this.state.isAuthenticated) return <Navigate to={this.getRedirectPath()} replace />;

    const { errors, hidden, password_check } = this.state;

    return (
      <div className="auth-root">

        {/* ── Left Panel — dark brand side with animated dots ── */}
        <div className="auth-left">
          {/* WebGL dot-matrix canvas — sits behind all content */}
          <div style={{ position: "absolute", inset: 0, zIndex: 0 }}>
            <CanvasRevealEffect
              animationSpeed={3}
              colors={[[255, 255, 255], [255, 255, 255]]}
              dotSize={4}
              opacities={[0.04, 0.04, 0.06, 0.08, 0.1, 0.12, 0.16, 0.2, 0.25, 0.3]}
              showGradient={false}
              reverse={false}
            />
          </div>

          <div className="auth-logo">
            <BlackLogo />
          </div>

          <div className="auth-hero">
            <div className="auth-hero-badge">
              <span className="auth-hero-badge-dot"></span>{this.props.t("auth_time_tracking_simplified")}</div>
            <h1><Trans i18nKey="loginHero" components={{ strong: <span /> }} /></h1>
            <p>{this.props.t("auth_log_time_effortlessly_manage_projects_and_gain_insights_into_how_your_team_spends_their_day")}</p>

            <div className="auth-features">
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_one_click_timer_start_stop")}</span>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M9 9h6M9 12h6M9 15h4"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_detailed_project_client_reports")}</span>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_team_collaboration_workspace_sharing")}</span>
              </div>
              <div className="auth-feature-item">
                <div className="auth-feature-icon">
                  <svg viewBox="0 0 24 24"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
                </div>
                <span className="auth-feature-text">{this.props.t("auth_weekly_reports_sent_to_your_inbox")}</span>
              </div>
            </div>
          </div>

          <div className="auth-stats">
            <div className="auth-stat-item">
              <div className="auth-stat-value">77+</div>
              <div className="auth-stat-label">{this.props.t("auth_active_users")}</div>
            </div>
            <div className="auth-stat-item">
              <div className="auth-stat-value">99.9%</div>
              <div className="auth-stat-label">{this.props.t("auth_uptime")}</div>
            </div>
            <div className="auth-stat-item">
              <div className="auth-stat-value">{this.props.t("auth_free")}</div>
              <div className="auth-stat-label">{this.props.t("auth_to_get_started")}</div>
            </div>
          </div>
        </div>

        {/* ── Right Panel — light form area ── */}
        <div className="auth-right">
          <motion.div
            className="auth-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, ease: "easeOut" }}
          >
            <LanguageSelector />
            <div className="auth-card-header">
              <h2>{this.props.t("auth_welcome_back")}</h2>
              <p>{this.props.t("auth_sign_in_to_your_minutezilla_account_to_continue_tracking")}</p>
            </div>

            {/* Social login */}
            <div className="auth-social-row">
              <GoogleSignInButton
                className="auth-social-btn auth-btn-google"
                onSuccess={responseGoogle}
                onError={googleError}
              >
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
                </svg>{this.props.t("auth_continue_with_google")}</GoogleSignInButton>

              {APPLE_SIGNIN_ENABLED && (
                <button className="auth-social-btn auth-btn-apple" onClick={() => window.AppleID && window.AppleID.auth.signIn()}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                  </svg>{this.props.t("auth_continue_with_apple")}</button>

              )}
            </div>

            <div className="auth-divider">{this.props.t("auth_or_sign_in_with_email")}</div>

            <div className="auth-alert-wrap">
              <Alert alerts="" />
            </div>

            <form className="auth-form" onSubmit={this.loginUser} noValidate>
              {/* Email */}
              <div className="auth-field">
                <label className="auth-label" htmlFor="login-email">{this.props.t("auth_email_address")}</label>
                <div className="auth-input-wrap">
                  <input
                    className={`auth-input${errors.email ? " is-error" : ""}`}
                    type="email"
                    id="login-email"
                    name="email"
                    placeholder={this.props.t("auth_you_example_com")}
                    value={this.state.email}
                    onChange={this.onChange}
                    onKeyDown={this.hanldeKeydown}
                    autoComplete="username"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                  />
                </div>
                {errors.email && <span className="auth-error-msg">{this.props.t(errors.email)}</span>}
              </div>

              {/* Password */}
              <div className="auth-field">
                <label className="auth-label" htmlFor="login-password">{this.props.t("auth_password")}</label>
                <div className="auth-input-wrap">
                  <input
                    className={`auth-input auth-input-with-toggle${errors.password ? " is-error" : ""}`}
                    type={hidden ? "password" : "text"}
                    id="login-password"
                    name="password"
                    placeholder="••••••••"
                    value={this.state.password}
                    onChange={this.onChange}
                    onKeyUp={this.checkPassword}
                    onKeyDown={this.hanldeKeydown}
                    autoComplete="current-password"
                  />
                  <button type="button" className="auth-input-toggle" onClick={this.toggleShow} aria-label={this.props.t(hidden ? "showPassword" : "hidePassword")}>
                    {hidden ? (
                      <svg viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
                    ) : (
                      <svg viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
                    )}
                  </button>
                </div>
                {errors.password && <span className="auth-error-msg">{this.props.t(errors.password)}</span>}
                <div className="auth-pw-check">
                  <span className={`auth-pw-pill${password_check.length  ? " active" : ""}`}>{this.props.t("auth_8_chars")}</span>
                  <span className={`auth-pw-pill${password_check.letter  ? " active" : ""}`}>{this.props.t("auth_uppercase")}</span>
                  <span className={`auth-pw-pill${password_check.number  ? " active" : ""}`}>{this.props.t("auth_number")}</span>
                  <span className={`auth-pw-pill${password_check.special ? " active" : ""}`}>{this.props.t("auth_special")}</span>
                </div>
              </div>

              <div className="auth-remember-row">
                <label className="auth-remember-label">
                  <input
                    type="checkbox"
                    className="auth-remember-checkbox"
                    checked={this.state.rememberMe}
                    onChange={(e) => this.setState({ rememberMe: e.target.checked })}
                  />
                  <span>{this.props.t("auth_remember_me")}</span>
                </label>
                <NavLink to="/password/forgot" className="auth-forgot-anchor">{this.props.t("auth_forgot_password")}</NavLink>
              </div>

              <button type="button" className="auth-submit-btn" onClick={this.loginUser}>{this.props.t("auth_sign_in_to_minutezilla")}</button>
            </form>

            <p className="auth-footer-link">{this.props.t("auth_don_t_have_an_account")}<NavLink to="/">{this.props.t("auth_sign_up_for_free")}</NavLink>
            </p>
          </motion.div>
        </div>

      </div>
    );
  }

  getRedirectPath = () => {
    const params = new URLSearchParams(this.props.location.search);
    return params.get("redirect") || "/dashboard";
  };
}

Login.propTypes = {
  login: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({ invite_ids: state.invite_ids });
const mapDispatchToProps = (dispatch) => bindActionCreators({ login, loadUser, setInvite, removeInvite, setAlert }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Login));
